import { connect } from "react-redux";
import {
  Box,
  Table,
  Text,
} from "@chakra-ui/react";
import WaitingTimeLineGraph from "../../charts/daily/WaitingTimeLineGraph";
import { formatTime, formatNumber } from "../../../../store/helpers";

const WaitingTimeTable = ({ table, chart, reportIndex }) => {
  return (
    <Box mt={10}>
      <Box>
        {table.map((a, index) => (
          <Box className="reportContainer" key={index}>
            <Box mb="10px">
              <h3>
                {reportIndex}. {index + 1}. {a.name}
              </h3>
            </Box>
            <Table.Root key={index} className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Waiting Time</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /ticket</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /hour</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader>Max</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatNumber(a.totalTickets)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatTime(a.totalWaitingTime)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.avgWaitingTimePerTicket)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.avgWaitingTimePerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.minWaitingTimePerHour)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.maxWaitingTimePerHour)}</Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
            <Box className="singleSeriesChartBlock">
              <WaitingTimeLineGraph
                title={`Entire Organization: Hour by Hour Comparison`}
                chart={chart}
                chartHeight="300px"
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { defaultReducer } = state;
  return {
    tickets: defaultReducer.tickets,
  };
};

export default connect(mapStateToProps, {})(WaitingTimeTable);
